import React, { lazy, useEffect } from "react";
import { useNavigate, useRoutes } from "react-router-dom";
import ChooseSignUp from "../Auth/ChooseSignUp";
import ConsultantSignUp from "../Auth/consultAuth/ConsultantSignUp";
import HospitalSignUp from "../Auth/hospitalAuth/HospitalSignUp";
import ComingSoon from "../BloodDonation/ComingSoon";
// import LandingPage from "../Home/LandingPage";
import ConsultantSignUp2 from "../Auth/consultAuth/ConsultantSignup2";
import { useAppSelector } from "../Global/Store";
import NotFoundPage from "../Home/NotFoundPage/NotFoundPage";
import ConsultantSignin from "../Auth/consultantSignin";

const LandingPage = lazy(() => import("../Home/LandingPage"));
const SignUp = lazy(() => import("../Auth/userAuth/SignUp"));
const UserSignUp2 = lazy(() => import("../Auth/userAuth/userSignUp2"));
const UserSignUp3 = lazy(() => import("../Auth/userAuth/UserSignUp3"));
const Signin = lazy(() => import("../Auth/Signin"));
const InputOTP = lazy(() => import("../Auth/InputOTP"));
// const NotFoundPage = lazy(() => import("../Home/NotFoundPage/NotFoundPage"));

const HomeRoutes = () => {
  const getUser = useAppSelector((state) => state?.currentUser);

  const navigate = useNavigate();

  useEffect(() => {
    if (getUser?.next_of_kin) {
      navigate("/dashboardhome", { replace: true });
    }
  }, []);

  const element = useRoutes([
    {
      path: "/",
      element: <LandingPage />,
    },
    {
      path: "/signup",
      element: <ChooseSignUp />,
    },
    {
      path: "/signin",
      element: <Signin />,
    },
    {
      path: "/consultantSignin",
      element: <ConsultantSignin />,
    },
    {
      path: "/otp",
      element: <InputOTP />,
    },
    {
      path: "/usersignup2",
      element: <UserSignUp2 />,
    },
    {
      path: "/usersignup3",
      element: <UserSignUp3 />,
    },
    {
      path: "/donateblood",
      element: <ComingSoon />,
    },
    {
      path: "/usersignup1",
      element: <SignUp />,
    },
    {
      path: "/consultantsignup",
      element: <ConsultantSignUp />,
    },
    {
      path: "/consultantsignup2",
      element: <ConsultantSignUp2 />,
    },
    {
      path: "/signhospital",
      element: <HospitalSignUp />,
    },
    // {
    //   path: "*",
    //   element: <NotFoundPage />,
    // },
  ]);
  return element;
};

export default HomeRoutes;
